import React from 'react';
import PropTypes from 'prop-types';
import { WidgetPreviewContainer } from 'netlify-cms-ui-default';
import { jsx as ___EmotionJSX } from "@emotion/core";

function ObjectPreview({
  field
}) {
  return ___EmotionJSX(WidgetPreviewContainer, null, field && field.get('fields') || field.get('field') || null);
}

ObjectPreview.propTypes = {
  field: PropTypes.node
};
export default ObjectPreview;